<template>
  <div class="home">
    <div id="mapContainer" class="mapContainer"></div>
    <div class="backBtn" @click="$router.back()">
      <van-icon name="arrow-left" size="20" />
    </div>
    <div class="buttonContainer">
      <van-button round block type="info" @click="goToAmapNavigation">
        导航
      </van-button>
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import { navigateToLocation } from '@/utils/wxWebview';
// 高德安全代理服务器域名或地址
window._AMapSecurityConfig = {
  // 分销系统服务器，nginx代理
  serviceHost: "https://ad.xbov.cn/_AMapService",
}
export default {
  name: "map",
  components: {},
  data() {
    return {
      mediaPosition: [],
      name: '目的地',
      address: '',
      map: null,
      marker: null,
    };
  },
  async mounted() {
    const query = this.$route.query;
    this.mediaPosition = [query.lng, query.lat]
    this.name = query.name || '目的地';
    this.address = query.address || '';
    this.initMap();
  },
  methods: {
    async initMap() {
      try {
        // 确保配置对象存在
        const mapConfig = {
          key: "e3d6b8b5e0628e58fca3498af11c0637",
          version: "2.0",
          plugins: ["AMap.Scale", "AMap.ToolBar", "AMap.Geolocation"]
        };

        const AMap = await AMapLoader.load(mapConfig);

        // 使用 ref 存储地图实例
        this.map = new AMap.Map("mapContainer", {
          center: this.mediaPosition,
          zoom: 11
        });

        // 添加标记点
        this.marker = new AMap.Marker({
          position: this.mediaPosition,
          title: "目的地"
        });

        this.map.add(this.marker);
      } catch (error) {
        console.error('地图加载失败:', error);
      }
    },
    async goToAmapNavigation() {
      try {
        await navigateToLocation({
          lng: this.mediaPosition[0],
          lat: this.mediaPosition[1],
          name: this.name,
          address: this.address
        });
      } catch (e) {
        console.error(e);
        this.$toast(e.message || '导航功能暂不可用');
      }
    }
  }
}

</script>

<style scoped lang="less">
.home {
  width: 100%;
  height: 100vh;
  position: relative;
}
.backBtn {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 10;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mapContainer {
  width: 100%;
  height: 100%; /* 确保地图容器占满父容器 */
}

.buttonContainer {
  position: absolute;
  bottom: 50px;
  width: 100%;
  height: 50px;
}
</style>
